import { render, staticRenderFns } from "./ScientificWork.vue?vue&type=template&id=03cfdc40&scoped=true&"
import script from "./ScientificWork.vue?vue&type=script&lang=js&"
export * from "./ScientificWork.vue?vue&type=script&lang=js&"
import style0 from "./ScientificWork.vue?vue&type=style&index=0&id=03cfdc40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03cfdc40",
  null
  
)

export default component.exports